<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-bus-alt"></em> Registration Form: {{student.registration_id}}</h1>
			</div>
			<div class="col-12 col-md-6 col-lg-4 text-right">
				<router-link to="/admin" class="btn btn-primary"><em class="fas fa-times"></em> Close</router-link>
			</div>
		</div>

		<fieldset>
			<legend>Student Information</legend>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Student ID</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.student_id}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Date of Birth</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.dob + "T09:00:00" | longDate}}
						</div>
					</div>
				</div>
			</div>
			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>School</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{schoolName(student.school_id)}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Grade</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.grade}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>School Board</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.district_id}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>First Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.fname}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Last Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.lname}}
						</div>
					</div>
				</div>
			</div>
			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Street Number</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.street_number}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Apartment</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.apartment}}
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Street Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.street_name}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>City</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.city}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Postal Code</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.postalcode}}
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<fieldset id="medical">
			<legend>Prevalent Medical Conditions</legend>

			<div class="form-row mb-2">
				<div class="col-12">
					<label>Prevalent Medical Conditions</label>
				</div>
				<div class="col-12 col-lg-4"></div>
				<div class="col-12 col-lg-8">
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.anaphylaxis == 1, 'fa-times': student.anaphylaxis != 1}"></em> Anaphylaxis</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.asthma == 1, 'fa-times': student.asthma != 1}"></em> Asthma</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.diabetes == 1, 'fa-times': student.diabetes != 1}"></em> Diabetes</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.epilepsy == 1, 'fa-times': student.epilepsy != 1}"></em> Epilepsy</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.medical_na == 1, 'fa-times': student.medical_na != 1}"></em> None of the above</label>
					</div>
				</div>
			</div>

			<div v-if="student.anaphylaxis == 1 || student.asthma == 1 || student.diabetes == 1 || student.epilepsy == 1">
				<div class="form-row mb-2">
					<div class="col-12">
						<label>Types(s) of prescription medication used for the identified Prevalent Medical Conditions and carried with student in the event of a health emergency:</label>
					</div>
					<div class="col-12 col-lg-4"></div>
					<div class="col-12 col-lg-8">
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.epipen == 1, 'fa-times': student.epipen != 1}"></em> Epi Pen (or similar)</label>
						</div>
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.glucagon == 1, 'fa-times': student.glucagon != 1}"></em> Glucagon Spray</label>
						</div>
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.inhaler == 1, 'fa-times': student.inhaler != 1}"></em> Rescue Inhaler</label>
						</div>
					</div>
				</div>
				<div class="form-row mb-2">
					<div class="col-12">
						<label>Student carries prescription medication on their person to self-administer during a health emergency and it is located in:</label>
					</div>
					<div class="col-12 col-lg-4"></div>
					<div class="col-12 col-lg-8">
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.bpfront == 1, 'fa-times': student.bpfront != 1}"></em> Back pack - front pocket</label>
						</div>
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.bpside == 1, 'fa-times': student.bpside != 1}"></em> Back pack - side pocket</label>
						</div>
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.bpmain == 1, 'fa-times': student.bpmain != 1}"></em> Back pack - main body</label>
						</div>
						<div>
							<label><em class="fas fa-fw" :class="{'fa-check': student.bpwaist == 1, 'fa-times': student.bpwaist != 1}"></em> Waist pack</label>
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<fieldset>
			<legend>AM Transportation Requirements</legend>

			<div class="form-row mb-2">
				<div class="col-12">
					<label>Do you need transportation in the morning?</label>
				</div>
				<div class="col-12 col-lg-4"></div>
				<div class="col-12 col-lg-8">
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.am_trans == 'primary', 'fa-times': student.am_trans != 'primary'}"></em> Yes, based on the address listed on your student file.</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.am_trans == 'no', 'fa-times': student.am_trans != 'no'}"></em> No, transportation is not needed in the morning.</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.am_trans == 'secondary' && student.am_trans2 == 'alt', 'fa-times': student.am_trans != 'secondary' || student.am_trans2 != 'alt'}"></em> Yes, based on a secondary caregiver address.</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.am_trans == 'secondary' && student.am_trans2 == 'new', 'fa-times': student.am_trans != 'secondary' || student.am_trans2 != 'new'}"></em> Yes, based on an address we are moving to.</label>
					</div>
				</div>
			</div>

			<fieldset v-if="student.am_trans == 'secondary'">
				<legend v-show="student.am_trans2 == 'secondary'">Secondary Caregiver Address Information</legend>
				<legend v-show="student.am_trans2 == 'new'">New Address Information</legend>

				<div class="form-row">
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Street Number</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.am_alt_street_number}}
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Apartment</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.am_alt_apartment}}
							</div>
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Street Name</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.am_alt_street_name}}
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>City</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.am_alt_city}}
							</div>
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Postal Code</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.am_alt_postalcode}}
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Requested Start Date</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.am_alt_start + "T09:00:00" | longDate}}
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		</fieldset>

		<fieldset>
			<legend>PM Transportation Requirements</legend>

			<div class="form-row mb-2">
				<div class="col-12">
					<label>Do you need transportation in the afternoon?</label>
				</div>
				<div class="col-12 col-lg-4"></div>
				<div class="col-12 col-lg-8">
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.pm_trans == 'primary', 'fa-times': student.pm_trans != 'primary'}"></em> Yes, based on the address listed on your student file.</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.pm_trans == 'no', 'fa-times': student.pm_trans != 'no'}"></em> No, transportation is not needed in the afternoon.</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.pm_trans == 'secondary' && student.pm_trans2 == 'alt', 'fa-times': student.pm_trans != 'secondary' || student.pm_trans2 != 'alt'}"></em> Yes, based on a secondary caregiver address.</label>
					</div>
					<div>
						<label><em class="fas fa-fw" :class="{'fa-check': student.pm_trans == 'secondary' && student.pm_trans2 == 'new', 'fa-times': student.pm_trans != 'secondary' || student.pm_trans2 != 'new'}"></em> Yes, based on an address we are moving to.</label>
					</div>
				</div>
			</div>

			<fieldset v-if="student.pm_trans == 'secondary'">
				<legend v-show="student.pm_trans2 == 'alt'">Secondary Caregiver Address Information</legend>
				<legend v-show="student.pm_trans2 == 'new'">New Address Information</legend>

				<div class="form-row">
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Street Number</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.pm_alt_street_number}}
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Apartment</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.pm_alt_apartment}}
							</div>
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Street Name</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.pm_alt_street_name}}
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>City</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.pm_alt_city}}
							</div>
						</div>
					</div>
				</div>

				<div class="form-row">
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Postal Code</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.pm_alt_postalcode}}
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6">
						<div class="form-row mb-2">
							<div class="col-12 col-md-6 col-lg-4">
								<label>Requested Start Date</label>
							</div>
							<div class="col-12 col-md-6 col-lg-8">
								{{student.pm_alt_start + "T09:00:00" | longDate}}
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		</fieldset>

		<fieldset>
			<legend>Parent/Guardian Electronic Signature and Contact Information</legend>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>First Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.applicant_fname}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Last Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.applicant_lname}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Phone Number</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							<a :href="'tel:' + student.applicant_phone" target="_blank">{{student.applicant_phone | phoneDisplay}}</a>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Email Address</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							<a :href="'mailto:' + student.applicant_email" target="_blank">{{student.applicant_email}}</a>
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Date</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.created | longDateTime}}
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<form @submit.prevent="save()">
			<fieldset>
				<legend>Internal Information</legend>

				<div class="form-row mb-2">
					<div class="col-12 col-md-6 col-lg-4">
						<label for="status">Status</label>
					</div>
					<div class="col-12 col-md-6 col-lg-8">
						<div class="btn-group d-flex justify-content-between d-block w-100" role="group" aria-label="Owned, leased, or financed">
							<button type="button" class="btn" :class="{'btn-primary': student.status == 'P', 'btn-secondary': student.status != 'P'}" @click="student.status = 'P'">
								<em class="fas fa-fw" :class="{'fa-check-circle': student.status == 'P', 'fa-circle-o': student.status != 'P'}"></em>
								Pending
							</button>
							<button type="button" class="btn" :class="{'btn-success': student.status == 'A', 'btn-secondary': student.status != 'A'}" @click="student.status = 'A'">
								<em class="fas fa-fw" :class="{'fa-check-circle': student.status == 'A', 'fa-circle-o': student.status != 'A'}"></em>
								Approved
							</button>
							<button type="button" class="btn" :class="{'btn-danger': student.status == 'D', 'btn-secondary': student.status != 'D'}" @click="student.status = 'D'">
								<em class="fas fa-fw" :class="{'fa-check-circle': student.status == 'D', 'fa-circle-o': student.status != 'D'}"></em>
								Declined
							</button>
						</div>
					</div>
				</div>

				<div class="form-row mb-2">
					<div class="col-12 col-md-6 col-lg-4">
						<label for="notes">Notes</label>
					</div>
					<div class="col-12 col-md-6 col-lg-8">
						<textarea name="notes" id="notes" v-model="student.notes" class="form-control"></textarea>
					</div>
				</div>

				<div class="form-row">
					<div class="col-12 text-center">
						<button type="submit" class="btn btn-primary mr-1"><em class="fas fa-save"></em> Save</button>
						<router-link to="/admin" class="btn btn-secondary ml-1"><em class="fas fa-times"></em> Close</router-link>
					</div>
				</div>
			</fieldset>
		</form>
	</div>
</template>

<script>
export default
{
	name: 'Form',
	data: function()
	{
		return {
			student: {
				student_id: null,
				dob: null,
				school_id: null,
				grade: null,
				fname: null,
				lname: null,
				district_id: null,
				street_number: null,
				street_name: null,
				apartment: null,
				city: null,
				postalcode: null,
				am_alt_start: null,
				am_alt_street_number: null,
				am_alt_street_name: null,
				am_alt_apartment: null,
				am_alt_city: null,
				am_alt_postalcode: null,
				pm_alt_start: null,
				pm_alt_street_number: null,
				pm_alt_street_name: null,
				pm_alt_apartment: null,
				pm_alt_city: null,
				pm_alt_postalcode: null,
				anaphylaxis: false,
				asthma: false,
				diabetes: false,
				epilepsy: false,
				medical_na: false,
				am_trans: null,
				am_trans_alt: 0,
				pm_trans: null,
				pm_trans_alt: 0,
				applicant_fname: null,
				applicant_lname: null,
				applicant_phone: null,
				applicant_email: null,
				applicant_tos: false,
				epipen: false,
				glucagon: false,
				inhaler: false,
				bpfront: false,
				bpside: false,
				bpmain: false,
				bpwaist: false,
				status: "P",
				notes: ""
			},
			schools: []
		}
	},
	mounted: function()
	{
		this.loadSchools();
		this.loadForm(this.$route.params.registration_id);
	},
	methods:
	{
		loadForm: function(registration_id)
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('GET', "/registration/forms/" + registration_id, null,
			function(data)
			{
				vm.student = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error loading registration form: " + response.responseText, true, null);
			});
		},
		save: function()
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('PUT', "/registration/forms/" + vm.student.registration_id, JSON.stringify(vm.student),
			function(data)
			{
				vm.student = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error saving registration form: " + response.responseText, true, null);
			});
		},
		loadSchools: function()
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('GET', "/registration/schools", null,
			function(data)
			{
				vm.schools = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error loading user schools: " + response.responseText, true, null);
			});
		},
		schoolName: function(school_id)
		{
			for(var i=0; i<this.schools.length; i++)
			{
				if(this.schools[i].school_id == school_id)
				{
					return this.schools[i].school_name;
				}
			}

			return school_id;
		}
	}
}
</script>
